<fw-dialog title="Create New Project" width="extra-small">
  <fw-dialog-content>
    <form class="create-project-form form-full-width">
      <fw-wrapped-input title="Select a Group" [required]="true">
        <fw-select
          maxOptionsHeight="300px"
          placeholder="Select Group..."
          test-id="create-project-group-select"
          width="100%"
          [formControl]="groupPicker"
        >
          @for (group of groupsWithAccess$ | async; track group._id) {
            <fw-menu-item [title]="group.label || group._id" [value]="group._id" />
          }
        </fw-select>
      </fw-wrapped-input>

      <fw-wrapped-input title="Project Name" [errorText]="generateProjectLabel()" [required]="true">
        <fw-text-input
          placeholder="Enter Project Name..."
          test-id="create-project-name-input"
          [formControl]="projectsLabel"
        />
      </fw-wrapped-input>
    </form>
  </fw-dialog-content>

  <fw-dialog-actions>
    <fw-button test-id="project-close-button" variant="outline" (click)="dialogRef.close()"> Cancel </fw-button>
    <fw-button
      test-id="project-create-button"
      [disabled]="!groupPicker.valid || !projectsLabel.valid"
      (click)="submit()"
    >
      Create
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
